import { SHIPPING_COUNTRIES_QUERY } from "@/graphql/shop";
import sortShippingCountries from "@/utils/sortShippingCountries";
import { useQuery } from "@apollo/client";

export default function useShippingCountries() {
  const { data: shippingData } = useQuery(SHIPPING_COUNTRIES_QUERY);

  const shippingCountries = shippingData
    ? sortShippingCountries(shippingData.shippingCountries)
    : [];

  return shippingCountries;
}
